import type { ReactElement } from 'react'

import { WorkflowSection } from '@ebalance/proto/bffuser/v1/workflow_template_model_pb'

import { PlaceholderPage } from '~/components/common/PlaceholderPage'
import {
  sectionReleaseGate,
  useSectionRelease,
} from '~/hooks/useSectionRelease'

/**
 * 週間の公開状態で route を開閉する。 page 自身は flag を知らない。
 * pending (取得前) は何も描かず、 未公開・取得失敗 (fail-closed) は今の開発中表示、 公開中だけ children を描く。
 */
export const WeeklySectionGate = ({
  children,
}: {
  children: ReactElement
}): ReactElement | null => {
  const gate = sectionReleaseGate(useSectionRelease())
  if (gate.state === 'pending') return null
  if (!gate.released.has(WorkflowSection.WEEKLY)) {
    return <PlaceholderPage routeKey="demandForecastWeekly" />
  }
  return children
}
